import styled from 'styled-components';
import { TextStyle } from 'components/text';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.neutral_500};
`;

export const ButtonTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.neutral_500};
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  ${TextStyle} {
    text-decoration: underline;
  }
`;

export const TitleWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.neutral_200};
  padding-bottom: 24px;
`;

export const HistoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-height: 70vh;
  padding: 24px 192px 8px 8px;
  overflow-y: scroll;
`;

export const EntryWrapper = styled.div`
  margin-top: 8px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
